import * as React from 'react';
import { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { area, textSet } from './constants';
import { textCollectionActionCreators } from 'app/infrastructure/translate/actions';
import { useSharedState } from 'app/infrastructure/redux/hooks';

export const withTexts = 
  (textMappings: Record<string, number>) => 
  <T extends object>(Component: React.ComponentType<T>) => 
  React.forwardRef(({...rest}: T & React.RefAttributes<unknown>, ref)  => {
  
  const dispatch: Dispatch<any> = useDispatch();
  const sharedState = useSharedState();
  const language = sharedState?.language?.value;

  useEffect(() => {
    if (language) {
      dispatch(textCollectionActionCreators.loadTextCollection([area], language));
    }
  }, [dispatch, language]);
  
  const textState = useSelector(state => state[area]?.texts?.texts);

  const textProps = Object.keys(textMappings).reduce((aggr, t) => {
    const id = textMappings[t];
    const textFromState = textState?.find(c => c.id.textSet === textSet && c.id.no === id);
    if (textFromState) {
      aggr[t] = textFromState.description;
    }
    return aggr;
  }, {});
  
  return <Component
    {...textProps}
    {...rest as T}
    ref={ref}
  />;
});
